import React from "react";
import { BadgeCheck, Stamp } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { useContent } from "@/lib/useContent";

export const VisaApprovals = () => {
  const approvals = useContent("visa_approvals");
  if (!approvals || approvals.length === 0) return null;
  return (
    <section className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="visa-approvals-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Visa Approval Gallery" title="Recently approved through Makchester" subtitle="A snapshot of successful applications handled by our consultants. Client details anonymised for privacy." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {approvals.map((a, i) => (
            <div key={i} className="mk-card p-0 overflow-hidden" data-testid={`visa-approval-${i}`}>
              {a.image ? (
                <div className="h-44 overflow-hidden"><img src={a.image} alt={`${a.country} visa approval`} loading="lazy" className="w-full h-full object-cover" /></div>
              ) : (
                <div className="h-24 bg-[#0A2E4D] relative flex items-center px-6">
                  <span className="text-4xl" aria-hidden>{a.flag}</span>
                  <Stamp size={64} className="absolute -right-2 -bottom-4 text-white/10 rotate-12" />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 border-2 border-emerald-400 text-emerald-300 rounded-lg px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] -rotate-6">Approved</span>
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-2 text-emerald-600 text-xs font-bold uppercase tracking-wider"><BadgeCheck size={14} /> Visa Approved</div>
                <h3 className="font-serif-display text-lg text-[#0A2E4D] mt-2">{a.country}</h3>
                <div className="mt-3 space-y-1.5 text-sm">
                  <div className="flex justify-between border-b border-dashed border-[#E5E7EB] pb-1.5"><span className="text-[#4B5563]">Visa Type</span><span className="font-semibold text-[#0A2E4D]">{a.visa_type}</span></div>
                  <div className="flex justify-between border-b border-dashed border-[#E5E7EB] pb-1.5 pt-1"><span className="text-[#4B5563]">Client</span><span className="font-semibold text-[#0A2E4D]">{a.client}</span></div>
                  <div className="flex justify-between pt-1"><span className="text-[#4B5563]">Approved</span><span className="font-semibold text-[#0A2E4D]">{a.date}</span></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
